<template>
    <div class="tooltip" :class="[{ open }, position, className]">
        <div class="tooltip-arrow"></div>
        <div class="tooltip-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        position: {
            type: String,
            default: 'bottom',
        },
        className: {
            type: String,
        },
        autoOpen:{
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            open: false,
        };
    },
    mounted() {
        if (!this.autoOpen) return;

        this.$el.parentElement.addEventListener('mouseenter', () => {
            this.open = true;
        });

        this.$el.parentElement.addEventListener('mouseleave', () => {
            this.open = false;
        });
    },
};

</script>

<style lang="scss">
    @import '../../style/common/Tooltip.scss';
</style>
